/* Procraft face lift: scroll reveal, gallery thumbs, room size calculator. No libraries. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* Reveal once */
  var els = document.querySelectorAll('[data-reveal]');
  if (!reduce && 'IntersectionObserver' in window) {
    root.classList.add('pc-motion');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
    /* Safety net: never leave content stranded invisible if the observer never
       fires for a node — tall pages, full-page screenshot tools that don't scroll
       the viewport, or background tabs. Reveal anything still hidden shortly after
       load; on-screen blocks have already animated in via the observer by then. */
    var revealAll = function () { els.forEach(function (el) { el.classList.add('is-in'); }); };
    if (document.readyState === 'complete') { setTimeout(revealAll, 1000); }
    else { window.addEventListener('load', function () { setTimeout(revealAll, 1000); }); }
  }

  /* Gallery: keep the thumbnail button's ring in step (theme.js swaps the photo) */
  document.querySelectorAll('.pc-thumb').forEach(function (b) {
    b.addEventListener('click', function () {
      var img = b.querySelector('img'); var main = document.querySelector('.media-main');
      if (img && main) { main.src = img.dataset.full; main.alt = img.dataset.alt || main.alt; }
      document.querySelectorAll('.pc-thumb').forEach(function (x) { x.classList.toggle('is-active', x === b); });
    });
  });

  /* Room size calculator: volume against each heater's rated range (manufacturer Table 1) */
  document.querySelectorAll('[data-sizer]').forEach(function (s) {
    var unit = 'ft';
    var ins = { l: s.querySelector('[data-dim="l"]'), w: s.querySelector('[data-dim="w"]'), h: s.querySelector('[data-dim="h"]') };
    var vol = s.querySelector('[data-vol]'), note = s.querySelector('[data-note]');
    var rows = Array.prototype.slice.call(s.querySelectorAll('[data-fit]'));
    var FT3 = 0.0283168;
    s.querySelectorAll('[data-unit]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.unit === unit) return;
        var k = b.dataset.unit === 'm' ? 0.3048 : 1 / 0.3048;
        ['l', 'w', 'h'].forEach(function (d) { var v = parseFloat(ins[d].value); if (v) ins[d].value = (v * k).toFixed(2).replace(/\.?0+$/, ''); });
        unit = b.dataset.unit;
        s.querySelectorAll('[data-unit]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        s.querySelectorAll('[data-u]').forEach(function (u) { u.textContent = unit; });
        ['l', 'w', 'h'].forEach(function (d) { ins[d].placeholder = unit === 'm' ? { l: '1.8', w: '1.5', h: '2.1' }[d] : { l: '6', w: '5', h: '7' }[d]; });
        run();
      });
    });
    function run() {
      var l = parseFloat(ins.l.value), w = parseFloat(ins.w.value), h = parseFloat(ins.h.value);
      rows.forEach(function (r) { r.classList.remove('is-fit'); r.querySelector('[data-tag]').textContent = ''; });
      note.hidden = true; s.classList.remove('has-result');
      if (!(l > 0 && w > 0 && h > 0)) { vol.textContent = 'Enter your room to see the fit.'; return; }
      var m3 = unit === 'ft' ? l * w * h * FT3 : l * w * h;
      var hm = unit === 'ft' ? h * 0.3048 : h;
      vol.textContent = 'Your room: ' + m3.toFixed(1) + ' m³' + (unit === 'ft' ? ' (' + Math.round(l * w * h) + ' cu ft)' : '');
      s.classList.add('has-result');
      var fits = rows.filter(function (r) { return m3 >= parseFloat(r.dataset.min) && m3 <= parseFloat(r.dataset.max); });
      fits.forEach(function (r, i) {
        r.classList.add('is-fit');
        r.querySelector('[data-tag]').textContent = fits.length > 1 && i === fits.length - 1 ? 'Fits, more headroom' : 'Fits';
      });
      var msgs = [];
      if (!fits.length) {
        var max = Math.max.apply(null, rows.map(function (r) { return parseFloat(r.dataset.max); }));
        msgs.push(m3 > max ? 'That is bigger than any one Procraft heater is rated for. Send us your measurements and we will help.'
                           : 'That is smaller than the smallest rated room. Send us your measurements and we will help.');
      }
      if (hm < 1.9) msgs.push('The manual asks for a room at least 1.9 m (6 ft 3 in) high.');
      if (msgs.length) { note.textContent = msgs.join(' '); note.hidden = false; }
    }
    ['l', 'w', 'h'].forEach(function (d) { ins[d].addEventListener('input', run); });
  });
})();
